/**
 * @file ComponentForm.style.js
 * Exports ComponentForm component styles.
 */

export default theme => ({
  select: {
    width: '100%'
  },
  selectLabel: {
    fontSize: '12px',
    marginTop: theme.spacing.unit * 2,
    display: 'block'
  },
  textField: {
    width: '100%',
    marginTop: theme.spacing.unit * 2
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit
  }
});



// WEBPACK FOOTER //
// ./src/components/ComponentForm/ComponentForm.style.js